import { SkeletonProps } from '@mui/material/Skeleton';
type AvatarVariant = 'circular' | 'rounded' | 'square';
export const avatarLoadingVariantMap: Record<AvatarVariant, SkeletonProps['variant']> = {
  circular: 'circular',
  rounded: 'rectangular',
  square: 'rectangular',
};
